module.exports = __webpack_public_path__ + "img/play.e30a3dda.svg";